import { render, staticRenderFns } from "./UserRFIDs.vue?vue&type=template&id=0bee6c80&"
import script from "./UserRFIDs.vue?vue&type=script&lang=ts&"
export * from "./UserRFIDs.vue?vue&type=script&lang=ts&"
import style0 from "./UserRFIDs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports